export default function MobileBurgerMenu() {
    let burger = document.querySelector('.burger-button');
    let menu_body = document.querySelector('#header-menu');
    let main_nav = document.querySelector('.main-nav');

    if (burger && menu_body && main_nav) {
        // Переключение меню при нажатии на бургер-кнопку
        burger.onclick = function () {
            toggleMenu();
        };

        // Закрытие меню при клике на затемненный фон (body:before)
        document.addEventListener("click", function (event) {
            if (
              document.body.classList.contains("active-menu") &&  // Меню открыто
              event.target === document.body  // Кликнули именно по body (background)
            ) {
                closeMenu();
            }
        });
    }

    function toggleMenu() {
        menu_body.classList.toggle("active");
        burger.classList.toggle("active");
        main_nav.classList.toggle("active");
        document.body.classList.toggle("active-menu");
    }

    function closeMenu() {
        menu_body.classList.remove("active");
        burger.classList.remove("active");
        main_nav.classList.remove("active");
        document.body.classList.remove("active-menu");
    }
}
